/*
 * @Author: DQL
 * @Date: 2020-03-27 13:17:16
 * @LastEditors: LZL
 * @LastEditTime: 2021-05-06 16:46:50
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config.js';

const { logApi } = config.ctx;

export const logService = {
  // 查询列表
  list: (params) => { return axios.get(`${logApi}/log/query`, { params: params }); },

  // 删除
  delete: (params) => { return axios.delete(`${logApi}/log/delete`, { data: params }); },

  // 导出
  export: (params) => { return axios.get(`${logApi}/log/action/export`, { responseType: 'blob', params }); }
};
